<template>
  <div class="evaluationDialog">
    <jd-dialog title="评价详情" :visible.sync="dialogValue" width="820px" @close="dialogClose" :isShowSure="false" :isShowCancel="false">
      <div class="top">
        <div class="top-name">
          <div class="img"><img :src="commentItem.picUrl" alt="" /></div>
          {{ commentItem.nickName }}
        </div>
        <span>{{ commentItem.creationTime }}</span>
      </div>
      <div class="center">
        <el-rate class="centerRate" v-model="commentItem.score" disabled show-text text-color="#666" :texts="texts" style="height:50px"> </el-rate>
        <span style="line-height: 20px;font-size: 15px;">
          {{ commentItem.content }}
        </span>
      </div>
      <div class="demo-image__preview">
        <el-image class="image" v-for="(item, i) in commentItem.imageList" :key="i" :src="item" :preview-src-list="commentItem.imageList"> </el-image>

        <div class="videoMask" v-if="commentItem.videoUrl">
          <img class="image" :src="commentItem.mainUrl" alt="" @click="showVideoDialog()" />
          <img class="mask" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/video-mask.png" @click="showVideoDialog()" alt="" />
        </div>
      </div>
    </jd-dialog>
    <!-- 视频放大组件 -->
    <transition name="fade">
      <video-play v-show="showVideo" :visible="showVideo" :videoData="videoData" @onClose="showVideo = false"></video-play>
    </transition>
  </div>
</template>

<script>
import videoPlay from "@/components/jhk/video-play.vue";

export default {
  components: {
    videoPlay,
  },
  props: {
    value: {
      type: Boolean,
    },
    commentItem: {},
  },
  watch: {
    value(val) {
      this.dialogValue = val;
    },
  },
  data() {
    return {
      dialogValue: false,
      texts: ["1.0星", "2.0星", "3.0星", "4.0星", "5.0星"],
      // srcList: [],
      showVideo: false,
      videoData: {},
    };
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("dialogClose");
    },
    showVideoDialog() {
      this.videoData = {
        mainUrl: this.commentItem.mainUrl,
        videoUrl: this.commentItem.videoUrl,
      };
      this.showVideo = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluationDialog {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    &-name {
      display: flex;
      align-items: center;
    }
    .img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      img {
        width: 100px;
      }
    }
  }
  .center {
    margin: 15px 0;
  }
  .image {
    width: 100px;
    height: 100px;
    margin-top: 10px;
    margin-right: 10px;
  }
  .videoMask {
    display: inline-block;
    position: relative;
    .mask {
      position: absolute;
      left: 50%;
      top: 56%;
      transform: translate(-50%, -50%);
    }
  }
}
.centerRate {
  /deep/.el-rate__icon {
    font-size: 35px !important;
  }
  /deep/.el-rate__text {
    font-size: 20px;
  }
}
</style>
